export default __webpack_public_path__ + "static/media/solucao-02.8b50da0c.webp";